import React from 'react'
import { URLSearchParams } from 'next/dist/compiled/@edge-runtime/primitives/url';
import { useRouter } from 'next/router'

import useKva, { LANDING_PAGE_LENDING } from './useKVA';

const originUrl = process.env.NEXT_PUBLIC_REACT_APP_LENDING_FORM

function removeUndefinedKeys(obj) {
  for (let key in obj) {
      if (obj[key] === undefined || obj[key] == null) {
          delete obj[key];
      }
  }
  return obj;
}

function useBuildSearchParams() {
  const router = useRouter()
  const { query } = router
  const [params, setParams] = React.useState(query)
  const isReady = router?.isReady
  const { addEventPageView } = useKva()


  React.useEffect(() => {
    if (isReady) {
      let {campaign_id, source, token, medium } = router.query
      // HACKED: fix production bug http://localhost:3000/#vay-von-kinh-doanh?token=eyJ0eX
      if (window.location.hash.indexOf("vay-von-kinh-doanh?") > 0) {
        const queryParams = new URLSearchParams(window.location.hash.split('?')[1]);
        token = queryParams.get('token');
        campaign_id = queryParams.get('campaign_id')
        source = queryParams.get('source')
        medium = queryParams.get('medium')
      }
      const isHaveRootSource = source || medium
      let referrer
      if (!isHaveRootSource) {
        source = 'landing_page'
      } else {
        referrer = 'landing_page'
      }

      const cleanObjParams = removeUndefinedKeys({ campaign_id, source, token, referrer })
      setParams(new URLSearchParams(cleanObjParams))

      if (cleanObjParams.source) {
        addEventPageView(LANDING_PAGE_LENDING, { source: cleanObjParams.source, campaign_id: cleanObjParams.campaign_id })
      } else {
        addEventPageView(LANDING_PAGE_LENDING) }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);

  return params }

export default function useApplyUrl() {
  const router = useRouter()
  const params = useBuildSearchParams()
  const token = params instanceof URLSearchParams ? params.get('token') : ''
  const [applyUrl, setApplyUrl] = React.useState(`${originUrl}`)

  React.useEffect(() => {
    if (params instanceof URLSearchParams) {
      setApplyUrl(`${originUrl}?${params}`)
    }
  }, [params])


  React.useEffect(() => {
    if (token) {
      router.replace(router.pathname, "", { shallow: true })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])



  return applyUrl
}